import { render } from "./historialRegistro.vue?vue&type=template&id=5fb28106&scoped=true"
import script from "./historialRegistro.vue?vue&type=script&lang=js"
export * from "./historialRegistro.vue?vue&type=script&lang=js"

import "./historialRegistro.vue?vue&type=style&index=0&id=5fb28106&lang=scss&scoped=true"

import exportComponent from "C:\\xampp-80\\htdocs\\v2crmred\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fb28106"]])

export default __exports__